var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 16",
    width: 15,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#fe7201}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m7.7 15.5c0 0 1.6-3.9 2.5-4.9 1-1 4.8-2.8 4.8-2.8 0 0-3.9-1.6-4.9-2.5-1-1-2.8-4.8-2.8-4.8 0 0-1.6 3.9-2.5 4.9-1 1-4.8 2.8-4.8 2.8 0 0 3.9 1.6 4.9 2.5 1 1 2.8 4.8 2.8 4.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrange);
export default __webpack_public_path__ + "static/media/icon_orange.3886d5235b545829c00459d985ed3f10.svg";
export { ForwardRef as ReactComponent };